// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seldiaimg{display:flex;flex-direction:column;justify-content:center;align-items:center;color:#7d7d7d}.seldiaimg__heading{margin:32px 0 0;font-style:normal;font-weight:600;font-size:22px;line-height:28px;text-align:center}.seldiaimg__paragraph{margin:6px 0 0;font-style:normal;font-weight:400;font-size:14px;line-height:150%;text-align:center}", ""]);
// Exports
module.exports = exports;
